import React, { useCallback, useContext, useMemo } from 'react'
import {
  Box, ImageLoader, ResponsiveContext, Text,
} from '@usap/uicomponents'
import PageTypeIdentifier from '@usap/carparts/src/shared/helpers/PageTypeIdentifier'
import StarCount from '../../common/StarIcon'
import CommentBestSeller from './CommentBestSeller'
import staticStyle from './BestSellerDisplay.css'

export default function BestSellerDisplay({
  item,
  reviewCount,
  Link,
  isBot,
}) {
  const responsiveContext = useContext(ResponsiveContext)
  let screenSize = 'large'
  if (responsiveContext.toLowerCase().includes('mobile')) {
    screenSize = 'small'
  }
  if (responsiveContext.toLowerCase().includes('tablet') || responsiveContext.toLowerCase().includes('laptop')) {
    screenSize = 'medium'
  }

  const reviewBoxCssWidth = useMemo(() => {
    if (screenSize === 'large') {
      return '395px'
    }
    if (screenSize === 'small') {
      return '100%'
    }
    return '48%'
  }, [screenSize])

  const styleMemo = useMemo(
    () => ({
      reviewBox: {
        width: reviewBoxCssWidth,
        minHeight: '261px',
        alignSelf: 'self-start',
        margin: 5,
        border: '1px solid rgb(224, 224, 224)',
        boxShadow: '0px 4px 6px -2px rgba(0, 0, 0, 0.3)',
        padding: 16,
        linkText: {
          color: 'rgb(5, 98, 155)',
          fontSize: screenSize === 'small' ? 14 : 16,
          fontWeight: 500,
          lineHeight: '24px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          webkitLineClamp: '3',
          webkitBoxOrient: 'vertical',
        },
      },
      headerInfoContainer: { width: screenSize === 'medium' ? 'auto' : '252px', paddingLeft: 10 },
    }),
    [reviewBoxCssWidth, screenSize],
  )

  const onClick = useCallback(() => PageTypeIdentifier.pdp(), [])

  return (
    <Box style={styleMemo.reviewBox}>
      <Box style={staticStyle.reviewBox.headerBox}>
        <Box style={staticStyle.imageContainer}>
          <Link
            to={item.link}
            onClick={onClick}
            style={staticStyle.reviewBox.anchorLink}
          >
            <ImageLoader
              source={item.image}
              src={item.image}
              width="100%"
              height="100%"
              style={staticStyle.imageLoader}
              isBot={isBot}
              cloudinaryParams="c_pad,f_auto,q_auto,dpr_auto,e_sharpen,w_100,h_100"
              overrideCloudinary={true}
            />
          </Link>
        </Box>
        <Box style={styleMemo.headerInfoContainer}>
          <Link to={item.link} onClick={onClick}>
            <Text style={styleMemo.reviewBox.linkText}>
              { item.formatProductTitle || item.productTitle }
            </Text>
          </Link>
          <Box style={staticStyle.sideBySide}>
            <Text style={staticStyle.reviewBox.priceTag}>
              $
              {item.price}
            </Text>
            <Text style={staticStyle.reviewBox.reviewCount}>
              (
              { reviewCount }
              &nbsp;
              { reviewCount > 1 ? 'Reviews' : 'Review' }
              )
            </Text>
          </Box>
        </Box>
      </Box>
      <Box style={staticStyle.reviewArea}>
        <Box style={staticStyle.sideBySideStarCount}>
          <StarCount ratings={item.rating} />
        </Box>
        <Box style={staticStyle.commentBox}>
          <CommentBestSeller text={item.reviewText} />
        </Box>
      </Box>
      <Box style={staticStyle.sideBySideVerifiedPurchaser}>
        <Text style={staticStyle.verifiedPurchaser.ownerText}>
          { item.reviewerName ? item.reviewerName : 'Anonymous' }
        </Text>
        <Box style={staticStyle.verifiedPurchaser}>
          <Text style={staticStyle.verifiedPurchaser.text}>VERIFIED PURCHASER</Text>
        </Box>
      </Box>
    </Box>
  )
}
